export const eventLesson = {
  id: 256957,
  period: {
    from: '2023-08-01T17:30:00.000+03:00',
    to: '2022-08-01T17:30:00.000+03:00'
  },
  type: {
    slug: 'lesson',
    title: 'Лекция'
  },
  link: '/lessons/256957',
  title: 'Интервью с кандидатом физико-математических наук, Ларюшиным Иваном Дмитриевичем',
  userRole: 'student',
  lectors: [
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: 'wowoow wowoow wowoow wowoow wowoow wowoow wowoow',
      avatar: 'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/thumb-5437d4b8df429d71dc241ab590ca2af0.png'
    },
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: 'wowoow',
      avatar: 'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/thumb-5437d4b8df429d71dc241ab590ca2af0.png'
    },
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: 'wowoow',
      avatar: 'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/thumb-5437d4b8df429d71dc241ab590ca2af0.png'
    },
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: 'wowoow',
      avatar: 'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/thumb-5437d4b8df429d71dc241ab590ca2af0.png'
    }
  ]
}

export const eventRecommend = {
  id: 256959,
  period: {
    from: '2022-08-01T17:30:00.000+03:00',
    to: null
  },
  type: {
    slug: 'event',
    title: 'Мероприятие'
  },
  link: '/events/256959',
  title: 'Секретный гость',
  userRole: 'speaker',
  lectors: [
    {
      id: 5378546,
      firstname: 'Александр',
      lastname: 'Волчек',
      description: 'CEO GeekBrains',
      avatar: [
        'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/thumb-5437d4b8df429d71dc241ab590ca2af0.png',
        'https://gbcdn.mrgcdn.ru/uploads/avatar/2680738/attachment/original-e897d7c5e618ad5073dc31644cedd390.png'
      ]
    }
  ]
}

export const teacherEvent = {
  id: 256957,
  period: {
    from: '2023-08-22T11:00:00+03:00',
    to: null
  },
  type: {
    slug: 'lesson',
    title: 'Лекция'
  },
  link: '/lessons/256957',
  title:
      // 'Вводный вебинар' ||
      'Знакомство с языком программирования C#, введение в базы данных',
  userRole: 'teacher',
  lectors: [
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: null,
      avatar: null
    }
  ],
  tags: [],
  extra: { groups: [2846, 2947, 2846, 2947] }
}

export const eventHomework = {
  id: 256957,
  period: {
    from: null,
    to: '2022-08-01T17:30:00.000+03:00'
  },
  type: {
    slug: 'homework',
    title: null
  },
  link: 'test',
  title: 'Сдать практическое задание к уроку 1. Курс «Гибкие методологии (Agile, SCRUM, Канбан и другие). ИТ-специалист»',
  userRole: 'student',
  lectors: [
    {
      id: 6013040,
      firstname: 'Мария',
      lastname: 'Максимова',
      description: null,
      avatar: null
    }
  ],
  tags: { homeworkType: 'Практическое задание' }
}
